import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import organizationDataState from "../atoms/organizationDataAtom";
import {
  getSubscriptionTier,
  getActiveClientLimit,
  canAddActiveClient,
  hasFeatureAccess,
  isTierAtLeast,
  getTierDisplayName,
} from "../utils/subscriptionUtils";

/**
 * Entitlements from already-loaded organization data (no extra Firestore reads).
 */
export default function useEntitlements() {
  const organizationData = useRecoilValue(organizationDataState);

  return useMemo(() => {
    const tier = getSubscriptionTier(organizationData);
    const activeClientLimit = getActiveClientLimit(tier);

    return {
      organizationData,
      tier,
      tierDisplayName: getTierDisplayName(tier),
      activeClientLimit,
      isUnlimitedClients: activeClientLimit === null,
      canAddActiveClient: (currentActiveCount) =>
        canAddActiveClient(currentActiveCount, tier),
      hasFeature: (featureName) =>
        hasFeatureAccess(organizationData, featureName),
      isTierAtLeast: (minTier) => isTierAtLeast(organizationData, minTier),
      isPro: tier === "pro" || tier === "special_pricing",
    };
  }, [organizationData]);
}
